import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCheckBadge';
/** Renders an SVG icon. */
const SvgCheckBadge = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.6 11.2a1 1 0 0 1 .2 1.4l-6 8a1 1 0 0 1-1.507.107l-4-4a1 1 0 1 1 1.414-1.414l3.185 3.185L20.2 11.4a1 1 0 0 1 1.4-.2"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.47 4.152c1.479-2.87 5.581-2.87 7.06 0a1.97 1.97 0 0 0 2.352.974c3.074-.983 5.975 1.918 4.992 4.992a1.97 1.97 0 0 0 .974 2.352c2.87 1.479 2.87 5.581 0 7.06a1.97 1.97 0 0 0-.974 2.352c.983 3.074-1.918 5.975-4.992 4.992a1.97 1.97 0 0 0-2.352.974c-1.479 2.87-5.581 2.87-7.06 0a1.97 1.97 0 0 0-2.352-.974c-3.074.983-5.975-1.918-4.992-4.992a1.97 1.97 0 0 0-.974-2.352c-2.87-1.479-2.87-5.581 0-7.06a1.97 1.97 0 0 0 .974-2.352c-.983-3.074 1.918-5.975 4.992-4.992a1.97 1.97 0 0 0 2.352-.974m5.282.916c-.734-1.424-2.77-1.424-3.504 0a3.97 3.97 0 0 1-4.74 1.963c-1.525-.488-2.965.952-2.477 2.478a3.97 3.97 0 0 1-1.963 4.74c-1.424.733-1.424 2.77 0 3.503a3.97 3.97 0 0 1 1.963 4.74c-.488 1.525.952 2.965 2.478 2.477a3.97 3.97 0 0 1 4.74 1.963c.733 1.424 2.77 1.424 3.503 0a3.97 3.97 0 0 1 4.74-1.963c1.525.488 2.965-.952 2.477-2.478a3.97 3.97 0 0 1 1.963-4.74c1.424-.733 1.424-2.77 0-3.503a3.97 3.97 0 0 1-1.963-4.74c.488-1.525-.952-2.965-2.478-2.477a3.97 3.97 0 0 1-4.74-1.963Z"
      />
    </svg>
  );
};
SvgCheckBadge.displayName = displayName;
export default SvgCheckBadge;
